export default __webpack_public_path__ + "static/media/header-notice.7ed10cbd.svg";